import useTranslation from "hooks/useTranslation";
import { Fragment } from "react";
import { useSelector } from "react-redux";
import { CONVS_CHARGE_LINK } from "utils/constants";
import { replaceKeyWithValue } from "utils/text";
import ChargeLink from "./ChargeLink";

const getContainer = ({ userData }) => userData.container.data;

function FooterText({ hasAgentConv, convType }) {
  const { getTranslation } = useTranslation("CHAT");
  const { t } = getTranslation();
  const container = useSelector(getContainer);

  const text_based_on_selected_convs = {
    otherConvs: t("TRANSFER_CONV_TO_ME"),
    closed: "تخصیص مکالمه به خود",
  };

  const text =
    text_based_on_selected_convs[convType] || t("SELECT_CONV_TO_START_CHAT");

  const convsChargeCount = +container?.account?.conversationCharge;
  const packageType = container?.package?.type;

  if (packageType === "expire") {
    return (
      <>
        {replaceKeyWithValue(
          t("UPGRADE_YOUR_PACKAGE"),
          "link",
          <ChargeLink link={CONVS_CHARGE_LINK} />
        ).map((x, i) => (
          <Fragment key={i}>{x}</Fragment>
        ))}
      </>
    );
  }

  if (+convsChargeCount === 0 && !hasAgentConv) {
    return (
      <>
        {replaceKeyWithValue(
          t("CHARGE_YOUR_CONVS"),
          "link",
          <ChargeLink link={CONVS_CHARGE_LINK} />
        ).map((x, i) => (
          <Fragment key={i}>{x}</Fragment>
        ))}
      </>
    );
  }

  return text;
}

export default FooterText;
